export const manifest = {
  screens: {
    scr_w2t33f: { name: "Upload", route: "/", state: {"screen":"upload"}, position: {"x":160,"y":220} },
    scr_o0btto: { name: "Review Fields", route: "/", state: {"screen":"review"}, position: {"x":1560,"y":220} },
    scr_sws6db: { name: "Done", route: "/", state: {"screen":"done"}, position: {"x":2960,"y":220} },
  },
  sections: {
    sec_j3qdsb: { name: "Upload Flow", x: 0, y: 0, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_j3qdsb", children: [
      { kind: "screen", id: "scr_w2t33f" },
      { kind: "screen", id: "scr_o0btto" },
      { kind: "screen", id: "scr_sws6db" },
    ] },
  ],
}
